import { Button, Stack, TextField, Typography } from "@mui/material"
import type { SxProps, Theme } from "@mui/material/styles"
import { ExpandableCommentText } from "../ExpandableCommentText"
import { ButtonStyle, TypAnswer } from "../CommentItem/style"

export type CommentEditState = { commentId: number; original: string; draft: string } | null

const editActionButtonSx = {
    ...TypAnswer,
    ...ButtonStyle,
    textTransform: "none" as const,
    "&:hover": {
        ...TypAnswer["&:hover"],
        backgroundColor: "transparent",
    },
}

type CommentEditableTextProps = {
    nodeId: number
    text: string
    editState: CommentEditState
    setDraft: (value: string) => void
    onConfirmSave: () => void | Promise<void>
    onCancelEdit: () => void
    isUpdatingComment: boolean
    expandableSx?: SxProps<Theme>
}

export const CommentEditableText = ({
    nodeId,
    text,
    editState,
    setDraft,
    onConfirmSave,
    onCancelEdit,
    isUpdatingComment,
    expandableSx,
}: CommentEditableTextProps) => {
    const isEditing = editState?.commentId === nodeId
    const draft = editState?.draft ?? ""
    const original = editState?.original ?? ""

    if (!isEditing) {
        return <ExpandableCommentText text={text} sx={expandableSx} />
    }

    const trimmed = draft.trim()
    const unchanged = trimmed === original.trim()
    const saveDisabled = isUpdatingComment || !trimmed || unchanged

    return (
        <Stack gap={1}>
            <TextField
                multiline
                fullWidth
                minRows={3}
                value={draft}
                onChange={(e) => setDraft(e.target.value)}
                size="small"
                disabled={isUpdatingComment}
                inputProps={{ maxLength: 65535 }}
            />
            <Stack direction="row" gap={2}>
                <Button
                    type="button"
                    variant="text"
                    disableRipple
                    disabled={saveDisabled}
                    onClick={() => void onConfirmSave()}
                    sx={editActionButtonSx}
                >
                    <Typography variant="pictonBlue-12-normal" component="span">
                        Сохранить
                    </Typography>
                </Button>
                <Button
                    type="button"
                    variant="text"
                    disableRipple
                    disabled={isUpdatingComment}
                    onClick={onCancelEdit}
                    sx={editActionButtonSx}
                >
                    <Typography variant="pictonBlue-12-normal" component="span">
                        Отмена
                    </Typography>
                </Button>
            </Stack>
        </Stack>
    )
}
